<template>
  <div >
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
      <md-dialog-title class = "heading">Inbound Remark</md-dialog-title>

      <md-dialog-content >
        <form id = "top"> 
          <div class = "down">
            <tr>
              <th>SeqNo:</th>
              <td>{{dataForm.inboundSeq}}</td>
            </tr>
            <tr>
              <th>IBS:</th>
              <td>{{dataForm.inboundShipment}}</td>
            </tr>
            <tr>
              <th>Appointment:</th>
              <td>{{dataForm.apptNo}}</td>
            </tr>
            
            <md-field >
              <label class = "textlabel" for="loadRemark">Remark</label>
               <!--<md-input v-model="dataForm.loadRemark"/>-->
               <md-textarea v-model="dataForm.loadRemark"/>
            </md-field>
          </div>
        </form>
        
        <div class = "heading">
          <calling-api-center :paths="['/api/w/fsi/WebSaveInbound']"></calling-api-center>
            <md-dialog-actions >
              <md-button class="custButtonForm md-raised" @click="doSaveUser"><span class="icons-center material-icons">edit</span>Update</md-button>
              <md-button class="md-raised custButtonForm " @click="cancalAction"><span class="icons-center material-icons">cancel</span>Leave</md-button>
            </md-dialog-actions>
        </div>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>

<style scoped>
@import '../../public/chrisForm.css';

form {
    min-width: 640px;
    margin: 5px;
    color: #000000;
    font-size: 24px;
  }

.heading {
    padding-top: 0px;
    padding-left: 0px;
    margin-bottom: 0;
    color: #000292;
    width: 92%;
    line-height: 2;
    font-size: 24px;
    font-family: Roboto Slab;
    margin-left: 10px;
  }

#top {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 16px;
  margin-top: 5px;
  margin-left: 0px;
}
#top th{
  text-align: left;
  color: #000292
}
#top td{
  padding-left: 10px;
  padding-top: 5px;
}

</style>

<script>
  import { mapGetters } from 'vuex';
  import callingApiCenter from "../components/CallingApiCenter.vue";
  import AutocompleteCcicLocationSelect from "./AutocompleteCcicLocationSelect.vue";
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';

  const getInitialdataForm = () => ({
    mode: "RMK",
    username: null,
    apptNo: null,
    inboundShipment: null,
    inboundSeq: null,
    loadRemark: null,

  });

  export default {
    //components: { },
    props: {
      mode: String,
      onRefresh: Function,
    },
    data: () => ({
      showDialog: false,
      dataForm: getInitialdataForm(),
      saveInboundRemarkRequest:{
        inboundShipment: " ",
        inboundSeq: " ",
        loadRemark: " ",
      },
    }),
    components: {
      AutocompleteCcicLocationSelect ,callingApiCenter
    },

    computed: {
      ...mapGetters([
        'getMasterDataByGroup',
        'getMasterDataName',
        'getUserProfile',
      ]),

    },

    validations: {
      dataForm: {
      
      },
    },
 
    methods: {

      openDialog(existingUser) {
        this.$store.commit('clearApiError');
       
       
        this.$v.dataForm.$reset();

        console.log(this.$v.dataForm.$invalid);
        this.dataForm = getInitialdataForm();
      
        if (existingUser) {
          
          console.log(existingUser);
            this.dataForm.mode = "RMK",
            this.dataForm.username = this.getUserProfile.username,
            this.dataForm.apptNo = existingUser.apptNo
            this.dataForm.inboundShipment = existingUser.inboundShipment
            this.dataForm.inboundSeq = existingUser.inboundSeq
            this.dataForm.loadRemark = existingUser.loadRemark      
        }

        this.showDialog = true;
      },

      cancalAction(){
          this.showDialog = false;
          this.$store.commit('clearApiError');
      },
      
      doSaveUser() {
          const request = this.dataForm
          //api.post('/api/w/fsi/WebSaveInbound',request)
          newAPIPost('/api/w/fsi/WebSaveInbound',request)
          this.showDialog = false;
          this.onRefresh(this.dataForm.loadRemark);
      },
   
    },
  }
      
</script>


